import { useEffect, useRef } from 'react';
import { getPreposition, getUrlParameter, replaceRouterQueryVariables } from '@portal-internet/core';
import Slider from 'components/3catinfo/Slider';
import { useModal } from 'hooks/3catinfo/useModal';
import ModalReels from 'components/3catinfo/Reels/ModalReels';
import PosterReel from 'components/3catinfo/Reels/PosterReel';
import __isEmpty from 'lodash/isEmpty';
import styles from './reels.module.scss';
import { useRouter } from 'next/router';

const codificarSlug = (url) => {
    return encodeURIComponent(url).replaceAll(/%/g, '__');
};

const descodificarSlug = (url) => {
    return decodeURIComponent(url.replace(/__/g, '%'));
};

const getTitol = (props) => {
    const { prefixTitol = '', titol, afegirPreposicioTitol = true, mostraTitol = true } = props;
    if (__isEmpty(titol) || mostraTitol === false) return '';
    if (__isEmpty(prefixTitol) || !afegirPreposicioTitol) return titol;
    return `${prefixTitol}${getPreposition(titol)}${titol}`;
};

const getParamsOtherReelsFromApiCall = (urlApi) => {
    return getUrlParameter(urlApi, 'frontal')
        ? `&origen=frontal&frontal=${getUrlParameter(urlApi, 'frontal')}`
        : `&origen=colleccio&id=${getUrlParameter(urlApi, 'id')}`;
};

const Reels = (props) => {
    const { items, urlDades, reelsSeccio, routerQuery, isReelCompartit = false, frontal, seccio } = props;
    const reelCompartit = useRef(props.reelCompartit);
    const isReelCompartitBool =
        isReelCompartit && replaceRouterQueryVariables(isReelCompartit, routerQuery) !== '{{routerQuery.shared_video}}';
    const router = useRouter();

    const paramsOtherReels = isReelCompartitBool
        ? replaceRouterQueryVariables(frontal, routerQuery)
        : getParamsOtherReelsFromApiCall(urlDades);

    const seccioPath = isReelCompartitBool ? replaceRouterQueryVariables(seccio, routerQuery) : router.asPath;
    const itemsModal = useRef(__isEmpty(reelsSeccio) ? items : reelsSeccio);

    const { setModal, removeModal } = useModal();
    const titol = getTitol(props);

    const handleCloseModal = () => {
        const url = seccioPath === '' || seccioPath.includes('{{') ? '/3catinfo' : seccioPath;
        router.push(descodificarSlug(url));

        setTimeout(() => {
            removeModal();
        }, 1500);
    };

    const handleOnClickElement = (id) => {
        setModal(<ModalReels items={itemsModal.current} idSelected={id} />, {
            onClickClose: isReelCompartit ? handleCloseModal : false,
            className: styles.reelModal,
            title: titol,
            keyDownCustom: true
        });
    };

    useEffect(() => {
        itemsModal.current = __isEmpty(reelsSeccio) ? items : reelsSeccio;

        const sharedReel = {
            seccio: codificarSlug(seccioPath),
            paramsOtherReels: codificarSlug(paramsOtherReels)
        };

        itemsModal.current = itemsModal.current?.map((item) => {
            item.sharedReel = sharedReel;
            return item;
        });

        if (isReelCompartit) {
            if (__isEmpty(reelCompartit.current)) {
                reelCompartit.current = {
                    id: 'no-video'
                };
            }
            const indexSharedReel = itemsModal.current?.findIndex((item) => item.id === reelCompartit.current.id);
            if (indexSharedReel < 0) {
                itemsModal.current = [{ ...reelCompartit.current, sharedReel }, ...itemsModal.current];
            }

            handleOnClickElement(reelCompartit.current.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [router.asPath]);

    return (
        <>
            {items && (
                <div className={styles.contReel}>
                    <Slider format='poster-reel' estilModul='poster-reel' titol={titol} fletxes='mig'>
                        {items?.map((item) => {
                            return (
                                <PosterReel
                                    key={`poster-reel-${item.id}`}
                                    item={item}
                                    mostraEntradeta={false}
                                    onClickElement={handleOnClickElement}
                                />
                            );
                        })}
                    </Slider>
                </div>
            )}
        </>
    );
};

export default Reels;
